import { Component, inject, Injector, OnInit } from '@angular/core';
import { Database, get, ref, remove } from "@angular/fire/database";
import { AuthService } from 'src/app/services/auth.service';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-eventmanager',
  templateUrl: './eventmanager.component.html',
  styleUrls: ['./eventmanager.component.css']
})
export class EventmanagerComponent extends BaseComponent implements OnInit {
  database = inject(Database);
  isAuthenticatedWithFirebase = false
  events: any = []
  eventsDisplay: any = []
  eventid: any = []
  sortArray: any = []
  showinfo = false
  aggregated: any
  selectedItems: any;
  nOlderThan7Days = 0
  exerciseid = ''
  playerid = ''
  type = ''
  eventsSize: number = 0

  constructor(injector: Injector, private authService: AuthService) {
    super(injector)
  }

  async ngOnInit(): Promise<void> {
    this.isAuthenticatedWithFirebase = await this.authService.initializeAuth(() => this.onSuccessfullLogin())
  }

  async signInWithGoogle() {
    this.isAuthenticatedWithFirebase = await this.authService.signInWithGoogle()
    if (this.isAuthenticatedWithFirebase) { await this.onSuccessfullLogin() }
  }

  private async onSuccessfullLogin() {
    await this.getData()
  }

  getData = async () => {
    // New structure: events/{exerciseid}/{eventid} and need to join scenarioid from exercises
    // 1. Load exercises to build exercise -> scenarioid map
    const exercisesSnap = await get(ref(this.database, 'exercises'))
    const exerciseScenarioMap: Record<string, any> = {}
    if (exercisesSnap.exists()) {
      const exercisesVal = exercisesSnap.val() || {}
      Object.entries(exercisesVal).forEach(([exId, exData]: [string, any]) => {
        if (exData && exData.scenarioid !== undefined) {
          exerciseScenarioMap[exId] = exData.scenarioid
        }
      })
    }

    // 2. Load nested events
    const eventsRef = ref(this.database, 'events')
    const snapshot = await get(eventsRef)
    if (!snapshot.exists()) return

    const rawEvents = snapshot.val() || {}
    const json = JSON.stringify(rawEvents)
    const sizeInBytes = new Blob([json]).size
    this.eventsSize = (sizeInBytes / 1024) // in KB
    this.eventid = []

    // 3. Flatten: events/{exerciseid}/{eventid} -> single list w/ exerciseid & scenarioid
    const flattened: any[] = []
    Object.entries(rawEvents).forEach(([exerciseid, eventsObj]: [string, any]) => {
      if (!eventsObj) return
      Object.entries(eventsObj).forEach(([eventId, eventData]: [string, any]) => {
        if (!eventData) return
        flattened.push({
          ...eventData,
          id: eventId,
          exerciseid: exerciseid,
          scenarioid: exerciseScenarioMap[exerciseid] ?? null
        })
      })
    })

    this.events = flattened
    this.nOlderThan7Days = 0
    const sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000
    this.events.forEach((item: any) => {
      item.datetime = this.convertTimestamp(item.timestamp)
      if (item.timestamp < sevenDaysAgo) {
        this.nOlderThan7Days++
      }
    })
    this.events.sort((a: any, b: any) => b.timestamp - a.timestamp)
    this.eventsDisplay = this.events
    this.aggregated = this.groupData(this.events, ['exerciseid', 'playerid', 'type'])
    console.log(this.aggregated)
  }
  
  showOnlyToday = () => {
    const today = new Date();
    const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0).getTime();
    this.eventsDisplay = this.events.filter((event: any) => event.timestamp >= startOfDay);
  }
  showLast7Days = () => {
    const sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
    this.eventsDisplay = this.events.filter((event: any) => event.timestamp >= sevenDaysAgo);
  }
  showAllEvents = () => {
    this.clear()
  }
  deleteOlderThan7Days = async () => {
    this.loader.show()
    const sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
    const eventsToDelete = this.events.filter((event: any) => event.timestamp < sevenDaysAgo);
    for (const event of eventsToDelete) {
      const eventRef = ref(this.database, `events/${event.id}`);
      await remove(eventRef);
    }
    await this.getData();
    this.loader.hide()
  }
  filter = () => {
    const exerciseid = this.exerciseid.trim()
    const playerid = this.playerid.trim()
    const type = this.type.trim()

    this.eventsDisplay = this.events.filter((event: any) => {
      const matchesExercise = exerciseid === '' || event.exerciseid === exerciseid
      const matchesPlayer = playerid === '' || event.playerid === playerid
      const matchesType = type === '' || event.type === type
      return matchesExercise && matchesPlayer && matchesType
    })
  }

  clear = () => {
    this.exerciseid = ''
    this.playerid = ''
    this.type = ''
    this.eventsDisplay = this.events;
  }
  groupData(records: any[], groupFields: string[]): any[] {
    const groupRecursive = (data: any[], fields: string[], remainingFields: string[]): any[] => {
      if (remainingFields.length === 0) {
        return data
      }

      const currentField = remainingFields[0]
      const groups: any[] = []

      data.forEach(record => {
        const groupValue = record[currentField]

        if (groupValue == null) {
          return // Skip invalid records
        }

        let group = groups.find(g => g.group === groupValue)
        if (!group) {
          group = { group: groupValue, items: [] }
          groups.push(group)
        }

        group.items.push(record)
      })

      // Recurse into sub-groups
      groups.forEach(group => {
        group.items = groupRecursive(group.items, fields, remainingFields.slice(1))
      })

      return groups
    }

    return groupRecursive(records, groupFields, groupFields)
  }


  showEvents(level1: string, level2: string, level3: string) {
    const level1Group = this.aggregated.find((group: any) => group.group === level1)
    const level2Group = level1Group.items.find((group: any) => group.group === level2)
    const level3Group = level2Group.items.find((group: any) => group.group === level3)
    this.selectedItems = level3Group.items
  }

  deleteExercise(exerciseid: string) {
    // const exerciseRef = ref(this.database, 'events/' + exerciseid);
    // remove(exerciseRef)
    // this.getData()
  }

  edit(exercise: any) {
    // if (exercise == null){ // add new exercise
    //   let newExerciseid = this.generateExerciseId()
    //   this.router.navigate(['exerciseedit'],{ queryParams: { id:newExerciseid } })
    // }else{
    //   this.router.navigate(['exerciseedit'],{ queryParams: { id:exercise.id } } )
    // }
  }
}
